import React from 'react';
import Backdrop from '@mui/material/Backdrop';
import Modal from '@mui/material/Modal';
import Grow from '@mui/material/Grow';
import { Box, Button, Grid, IconButton, TextField } from '@mui/material';
import { HighlightOffRounded } from '@mui/icons-material';
import './Modal.styles.scss';



type TModalProps = {
    open: boolean,
    onClose: ((event: {}, reason: "backdropClick" | "escapeKeyDown") => void) | undefined , 
    closeClick: () => void,
}

const CModal:React.FC<TModalProps> = ({
    open,
    onClose,
    closeClick,
}) => {




  return (
    <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        onClose={onClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Grow in={open}>
          <div className='c-modal '>
            <IconButton className='close-icon'
                        size="large" 
                        color='inherit'
                        onClick={closeClick}>
                <HighlightOffRounded />
            </IconButton>
            <img
                src={require("@/assets/images/png/avatar.png")}
                alt="sidebar-logo"
                className="modal-avatar"
            />
            <div className="header-part">
              <h1 className="title">Mon profil</h1>
            </div>

            <div className="form-part">
              <Box>
                <Grid container spacing={3} columnSpacing={3} >
                  <Grid item xs={12} sm={12} lg={6}>
                    <TextField placeholder="Votre nom"
                      disabled
                      variant="outlined"
                      label="Nom"
                      value={"Fofana"}
                      id="name"
                      type="text" />
                  </Grid>
                  <Grid item xs={12} sm={12} lg={6}>
                    <TextField placeholder="Votre prénom"
                      disabled
                      variant="outlined"
                      label="Prénom"
                      value={"Soualio"}
                      id="surname"
                      type="text" />
                  </Grid>
                  <Grid item xs={12} sm={12} lg={12}>
                  <TextField placeholder="Votre adresse email"
                      disabled
                      id="outlined-disabled"
                      label="Adresse email"
                      value="fofanasoualison18@gmail.com"
                      type="email" />
                  </Grid>
                  <Grid item xs={12} sm={12} lg={6}>
                    <TextField placeholder="Votre identifiant"
                      disabled
                      variant="outlined"
                      label="Identifiant"
                      value={"12345678"}
                      id="id"
                      type="text" />
                  </Grid>
                  <Grid item xs={12} sm={12} lg={6}>
                    <TextField placeholder="Votre rôle"
                      disabled
                      variant="outlined"
                      label="Rôle"
                      value={"Administrateur"}
                      id="role"
                      type="text"
                      />
                  </Grid>

                  <Grid item xs={12} sm={12} lg={12}>
                    <Button variant="contained"
                      onClick={closeClick}
                      color='inherit'
                      size="large">
                      Fermer
                    </Button>
                  </Grid>
                </Grid>
              </Box>
            </div>

          </div>
        </Grow>
      </Modal>
  )
}

export default CModal;